/* ============================================================
 * RLC THEME TOKENS (JS) — GENERATED FILE, DO NOT EDIT BY HAND
 * ------------------------------------------------------------
 * For consumers that cannot use CSS variables — chiefly Ant
 * Design, which derives palettes from literal color values.
 *
 * Source:  brand/rlc/tokens.json
 * Rebuild: python3 scripts/utilities/build_brand_tokens.py
 *
 * PHASE C: change ACTIVE from LEGACY to RLC below. That plus
 * deleting the rlc-tokens-legacy.css import in index.jsx is the
 * entire rebrand switch.
 * ============================================================ */

/* eslint-disable */

export const RLC = {
  'surface': '#FFFFFF',
  'surface-subtle': '#FAFAFA',
  'surface-sunken': '#F5F5F5',
  'surface-muted': '#F0F0F0',
  'surface-raised': '#FFFFFF',
  'surface-accent': '#E6FAFC',
  'surface-inverse': '#063E44',
  'surface-inverse-alt': '#006666',
  'text-primary': '#333333',
  'text-secondary': '#666666',
  'text-muted': '#999999',
  'text-on-inverse': '#FFFFFF',
  'text-accent': '#006666',
  'text-link': '#006666',
  'text-link-hover': '#063E44',
  'text-link-inverse': '#00CCCC',
  'text-stat': '#003399',
  'border-subtle': '#EEEEEE',
  'border-default': '#DDDDDD',
  'border-strong': '#CCCCCC',
  'border-accent': '#006666',
  'action-primary': '#FF6600',
  'action-primary-text': '#FFFFFF',
  'action-primary-hover': '#E65C00',
  'action-secondary': '#006666',
  'action-secondary-text': '#FFFFFF',
  'action-secondary-hover': '#063E44',
  'action-disabled': '#CCCCCC',
  'action-disabled-text': '#FFFFFF',
  'focus-ring': '#003399',
  'state-success': '#15803D',
  'state-success-bg': '#EAF7EF',
  'state-warning': '#7A5D00',
  'state-warning-bg': '#FAF0DC',
  'state-error': '#9B1C2E',
  'state-error-bg': '#FAE8EB',
  'state-info': '#003399',
  'state-info-bg': '#E6ECF8',
};

export const LEGACY = {
  'surface': '#FFFFFF',
  'surface-subtle': '#FAFAFA',
  'surface-sunken': '#F5F5F5',
  'surface-muted': '#F0F0F0',
  'surface-raised': '#FFFFFF',
  'surface-accent': '#E7F3FF',
  'surface-inverse': '#0F1770',
  'surface-inverse-alt': '#2C5DD1',
  'text-primary': '#333333',
  'text-secondary': '#666666',
  'text-muted': '#999999',
  'text-on-inverse': '#FFFFFF',
  'text-accent': '#2C5DD1',
  'text-link': '#2C5DD1',
  'text-link-hover': '#0D5BAB',
  'text-link-inverse': '#FFFFFF',
  'text-stat': '#2C5DD1',
  'border-subtle': '#EEEEEE',
  'border-default': '#DDDDDD',
  'border-strong': '#CCCCCC',
  'border-accent': '#2C5DD1',
  'action-primary': '#2C5DD1',
  'action-primary-text': '#FFFFFF',
  'action-primary-hover': '#0F1770',
  'action-secondary': '#2C5DD1',
  'action-secondary-text': '#FFFFFF',
  'action-secondary-hover': '#0F1770',
  'action-disabled': '#CCCCCC',
  'action-disabled-text': '#FFFFFF',
  'focus-ring': '#1890FF',
  'state-success': '#52C41A',
  'state-success-bg': '#F6FFED',
  'state-warning': '#FAAD14',
  'state-warning-bg': '#FFE58F',
  'state-error': '#FF4D4F',
  'state-error-bg': '#FEE2E2',
  'state-info': '#1890FF',
  'state-info-bg': '#E7F3FF',
};

export const RADIUS = {
  'sm': '4px',
  'md': '6px',
  'lg': '10px',
  'pill': '999px',
};

// Phase C — set via meta.phase in brand/rlc/tokens.json.
export const ACTIVE = RLC;

export default ACTIVE;
